export default __webpack_public_path__ + "static/media/pietro-modal.776f93b6.jpg";